var $one = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelector(obj)
  }else{
    return document.querySelector(obj)
  }
}
var $$ = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelectorAll(obj)
  }else{
    return document.querySelectorAll(obj)
  }
};

function getStyle (obj, attr) { 
  obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle( obj )[attr]; 
}

NodeList.prototype.addEventListener = function(event, fn, useCapture){
  this.forEach(function(element) {
    element.addEventListener(event, fn, useCapture)
  })
} 
NodeList.prototype.show = function (displayType) {
  this.forEach(function(element) {
    element.style.display = displayType ? displayType : 'block';
  });
}
Element.prototype.show = function (displayType) {
  this.style.display = displayType ? displayType : 'block';
}
NodeList.prototype.hide = function () {
  this.forEach(function(element) {
    element.style.display = 'none';
  });
}
Element.prototype.hide = function () {
  this.style.display = 'none';
}

loadFunctionArr = window['loadFunctionArr'] || [];

document.addEventListener('DOMContentLoaded', function() {
    
  loadFunctionArr.forEach(function(fn){
    if(typeof fn == 'function'){
      fn();
    }
  });

  $$('[data-copy]').addEventListener('click', function(){
    var couponVal = this.getAttribute('data-copy');
    var text = this.getAttribute('data-text');
    copyText(couponVal.trim(), text);
    return false
  }); 

}, false);


function copyText(val, msg, okFn) {
  var inputObj = $$('#copyTextInput');
  if(inputObj.length){
    inputObj = inputObj[0];
    inputObj.value = val;
    inputObj.select();
    inputObj.setSelectionRange(0, inputObj.value.length),
        document.execCommand("Copy");
    inputObj.blur();
    var text = msg || "Copied Successfully";
    alert(text ).okBtn(function () {
        okFn && okFn();
    });
  }
}


if (!customElements.get('pp-paylater-div')) {

	class PpPaylaterDiv extends HTMLElement {
	  constructor() {
		super();
		this.LanguageList = ['DE', 'FR', 'ES', 'IT'];
		this.init();
	  }
	  init() {
		this.currentCurrency = (window.localStorage.getItem('currentCurrency') || 'EUR').toUpperCase();
		this.lan_code = (window.localStorage.getItem('lan_code') || 'en').toUpperCase();
		this.price = "0";
		if (!this.currentCurrency) {
		  return
		}
		// if (this.currentCurrency == "GBP") {
		//   this.lan_code = "GB"
		// } else if (this.currentCurrency == "EUR" && !this.LanguageList.includes(this.lan_code)) {
    //         this.lan_code = "DE"
    //     }
        /*
		var obj = document.querySelector('.main-product-info-container .langwill-money[data-currency=' + this.currentCurrency + ']');
    */
		var obj = document.querySelector('.main-product-info-container .langwill-money');
		if (obj) {
		  this.price = obj.innerHTML.replace('$', '').replace('€', '').replace(',','.');
		  try {
        if(this.LanguageList.includes(this.lan_code)){
          document.querySelector('#paypal-paylater-container').innerHTML = '<p data-pp-message data-pp-placement="product" data-pp-amount="' + this.price + '" data-pp-buyerCountry="' + this.lan_code + '"></p>';
          this.loadScript('https://www.paypal.com/sdk/js?components=buttons,messages&client-id=AZyIK02Qd-XtF3dfWKMbzOvkSY9S0SMh4jUI5nangHawM1TzkinGac9UNbNKcCV7iMHZzhHTNs9gVI21&currency=' + this.currentCurrency + '&enable-funding=paylater')
        }
		  } catch {

		  }
		} else {
		  setTimeout(() => {
			this.init();
		  }, 1000);
		}
	  }

	  loadScript(src, callback) {
		const script = document.createElement('script')
		script.src = src
		script.async = true

		script.onload = () => callback && callback()
		script.onerror = () => console.error('load error:', src)

		this.appendChild(script)
	  }

	}

	customElements.define('pp-paylater-div', PpPaylaterDiv);

  }